import "./Heading.css";
import clsx from "clsx";

const Heading = ({ children, className = "", level = 1 }) => {
  const levelClass = `heading-${level}`;

  return (
    <div className={clsx("custom-heading", levelClass, className)}>
      {children}
    </div>
  );
};

export default Heading;
